import { render, staticRenderFns } from "./BtnExcluirEntregaManual.vue?vue&type=template&id=55139812"
import script from "./BtnExcluirEntregaManual.vue?vue&type=script&lang=js"
export * from "./BtnExcluirEntregaManual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports